// extracted by mini-css-extract-plugin
export default {"field-wrapper":"SingleField_field-wrapper__SARWI"};